module.exports = "/build/images/mastercard_logo1.png?eace5c1628c32b64b019dd2599ee8cd0";


//////////////////
// WEBPACK FOOTER
// ./yii2/frontend/frontend-assets/src/_static/images/mastercard_logo1.png
// module id = 2430
// module chunks = 0